import React from "react";
import LoadingBackdrop from "../../universal/LoadingBackdrop";
import { MenuItemState } from "../reducer";
import Content from "./Content";

interface MenuItemCreateDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (state: MenuItemState) => void;
  title: string;
  initState?: MenuItemState;
  saving: boolean;
  variant: "MenuItem" | "MenuItemAppearance";
  allowSaveAsRecipe?: boolean;
}

const MenuItemDialog = ({ open, onClose, onSave, title, initState, saving, variant, allowSaveAsRecipe }: MenuItemCreateDialogProps) => {
  return saving ? (
    <LoadingBackdrop open={open} onClose={onClose} />
  ) : (
    <Content
      open={open}
      onClose={onClose}
      onSave={onSave}
      title={title}
      variant={variant}
      initState={initState}
      allowSaveAsRecipe={allowSaveAsRecipe}
    />
  );
};

export default MenuItemDialog;
